import React from "react"
import { Typography } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { mdiCloudUpload } from "@mdi/js"
import theme from "../../../theme"
import Icon from "@mdi/react"

type Props = {
    file: any;
    handleChangeFileInput: (event: any) => void;
    ref: any
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        textInput: {
            '& input, .MuiSelect-root': {
                padding: '12px 10px 12px !important',
            },

            '& .MuiInput-underline::before': {
                borderBottom: '1px solid #d8d8d8 !important',
            },
        },
        uploadInput: {
            cursor: 'pointer',
            alignSelf: 'center',
            position: 'absolute',
            top: '0',
            right: '0',
            width: '100%',
            height: '100%',
            opacity: '0',
        },
        labelInput: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            position: 'relative',
            padding: '15px',
            border: '1.5px dashed rgba(0, 0, 0, 0.25)',
            borderRadius: '4px',
            width: '100%',
            height: '150px',
            maxWidth: '500px',
            cursor: 'pointer'
        },
    }),
);

const File = (props: Props) => {
    const classes = useStyles();

    return (
        <>
            <label htmlFor="file" className={classes.labelInput}>

                <Icon
                    color={'#00000040'}
                    path={mdiCloudUpload}
                    size={2}
                />
                <Typography>
                    {props.file ? props.file?.name : 'فایل خود را اینجا رها کنید'}
                </Typography>
                <Typography
                    style={{
                        color: '#0375E8',
                        borderBottom: 'solid 1px #0375E8',
                    }}
                >
                    انتخاب فایل از کامپیوتر
                </Typography>
                <input
                    type="file"
                    name="file"
                    id="file"
                    onChange={props.handleChangeFileInput}
                    ref={props.ref}
                    className={classes.uploadInput}
                    hidden
                />
            </label>
        </>
    )
}

export default File;